import { Button } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import FileDownload from '@mui/icons-material/FileDownload';
import { useTranslation } from 'react-i18next';

type DndOrImportProps = {
  setNewFile: (a: File) => void;
  /** Contenu affiché dans la zone de dépôt, au-dessus du bouton de sélection. */
  header?: ReactNode;
};

const DndOrImport = ({ setNewFile, header }: DndOrImportProps) => {
  const { t } = useTranslation();
  const [dragOver, setDragOver] = useState<boolean>(false);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    setNewFile(droppedFile);
    setDragOver(false);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onMouseLeave={handleDragLeave}
      className={`dnd mb-1 ${dragOver ? 'drag-over' : ''}`}
    >
      {header}
      <Button
        id="select"
        variant="outlined"
        component="label"
        size="small"
        className="select-file-button"
      >
        <FileDownload sx={{ mr: 1 }} />
        {t('dndOrImport.selectFile')}
        <input
          hidden
          // multiple
          type="file"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const selectedFile = e.target.files?.length ? e.target.files[0] : null;
            setNewFile(selectedFile as File);
          }}
        />
      </Button>
      <p>{t('dndOrImport.or')}</p>
      {t('dndOrImport.dragAndDrop')}
    </div>
  );
};

export default DndOrImport;
